import { render, staticRenderFns } from "./ExamManagement.vue?vue&type=template&id=5564e19b"
import script from "./ExamManagement.vue?vue&type=script&lang=js"
export * from "./ExamManagement.vue?vue&type=script&lang=js"
import style0 from "./ExamManagement.vue?vue&type=style&index=0&id=5564e19b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports